import {OldEmitterConfig} from "pixi-particles";

export class ParticleSettings {
    public static readonly coinsConfigs: OldEmitterConfig = {
        "alpha": {
            "start": 1,
            "end": 1
        },
        "scale": {
            "start": 0.5,
            "end": 0.5,
            "minimumScaleMultiplier": 1
        },
        "color": {
            "start": "#ffffff",
            "end": "#ffffff"
        },
        "speed": {
            "start": 700,
            "end": 350,
            "minimumSpeedMultiplier": 2
        },
        "acceleration": {
            "x": 0,
            "y": 1500
        },
        "maxSpeed": 0,
        "startRotation": {
            "min": 235,
            "max": 310
        },
        "noRotation": false,
        "rotationSpeed": {
            "min": 10,
            "max": 70
        },
        "lifetime": {
            "min": 5,
            "max": 5
        },
        "blendMode": "normal",
        "frequency": 0.04,
        "emitterLifetime": 1,
        "maxParticles": 30,
        "pos": {
            "x": 360,
            "y": 600,
        },
        "addAtBack": false,
        "spawnType": "rect",
        "spawnRect": {
            "x": -50,
            "y": -25,
            "w": 100,
            "h": 50
        }
    };

    public static readonly nonCoinConfigs: OldEmitterConfig = {
        "alpha": {
            "start": 1,
            "end": 1
        },
        "scale": {
            "start": 0.8,
            "end": 1.2,
            "minimumScaleMultiplier": 1
        },
        "color": {
            "start": "#ffffff",
            "end": "#ffffff"
        },
        "speed": {
            "start": 700,
            "end": 350,
            "minimumSpeedMultiplier": 2
        },
        "acceleration": {
            "x": 0,
            "y": 1500
        },
        "maxSpeed": 0,
        "startRotation": {
            "min": 235,
            "max": 310
        },
        "noRotation": false,
        "rotationSpeed": {
            "min": 10,
            "max": 70
        },
        "lifetime": {
            "min": 5,
            "max": 5
        },
        "blendMode": "normal",
        "frequency": 0.03,
        "emitterLifetime": 1,
        "maxParticles": 50,
        "pos": {
            "x": 360,
            "y": 600,
        },
        "addAtBack": false,
        "spawnType": "rect",
        "spawnRect": {
            "x": -50,
            "y": -25,
            "w": 100,
            "h": 50
        }
    };


    public static readonly wincapCoinConfigs: OldEmitterConfig = {
        "alpha": {
            "start": 1,
            "end": 1
        },
        "scale": {
            "start": 0.5,
            "end": 0.75,
            "minimumScaleMultiplier": 1
        },
        "color": {
            "start": "#ffffff",
            "end": "#ffffff"
        },
        "speed": {
            "start": 700,
            "end": 350,
            "minimumSpeedMultiplier": 2
        },
        "acceleration": {
            "x": 0,
            "y": 3400
        },
        "maxSpeed": 0,
        "startRotation": {
            "min": 235,
            "max": 310
        },
        "noRotation": false,
        "rotationSpeed": {
            "min": 10,
            "max": 70
        },
        "lifetime": {
            "min": 3.5,
            "max": 3.5
        },
        "blendMode": "normal",
        "frequency": 0.1,
        "emitterLifetime": 15,
        "maxParticles": 40,
        "pos": {
            "x": 360,
            "y": 500,
        },
        "addAtBack": false,
        "spawnType": "rect",
        "spawnRect": {
            "x": -50,
            "y": -25,
            "w": 100,
            "h": 50
        }
    };

    public static readonly wincapNonCoinConfigs: OldEmitterConfig = {
        "alpha": {
            "start": 1,
            "end": 1
        },
        "scale": {
            "start": 0.8,
            "end": 1.2,
            "minimumScaleMultiplier": 1
        },
        "color": {
            "start": "#ffffff",
            "end": "#ffffff"
        },
        "speed": {
            "start": 700,
            "end": 350,
            "minimumSpeedMultiplier": 2
        },
        "acceleration": {
            "x": 0,
            "y": 3400
        },
        "maxSpeed": 0,
        "startRotation": {
            "min": 235,
            "max": 310
        },
        "noRotation": false,
        "rotationSpeed": {
            "min": 10,
            "max": 70
        },
        "lifetime": {
            "min": 3.5,
            "max": 3.5
        },
        "blendMode": "normal",
        "frequency": 0.1,
        "emitterLifetime": 15,
        "maxParticles": 50,
        "pos": {
            "x": 360,
            "y": 500,
        },
        "addAtBack": false,
        "spawnType": "rect",
        "spawnRect": {
            "x": -50,
            "y": -25,
            "w": 100,
            "h": 50
        }
    };
}